import React, { useState, useEffect } from 'react';
import { isNil, map, toLower, toUpper } from 'lodash';
import { get, post } from '../common/httpService';
import translateService from '../common/translateService';
import common from '../common/common';
import marketingAndAnalyticsService from '../services/marketingAndAnalytics/marketingAndAnalyticsService';

function ServiceLinksDesktop(props) {
  const [data, setData] = useState({
    language: '',
    languages: [],
    country: '',
    countries: [],
    currency: '',
    currencies: [],
    returnUrl: '',
    partners: [],
    helpUrl: '',
  });
  const [user, setUser] = useState({
    isAuthenticated: false,
    firstName: '',
    profileUrl: '',
    ordersUrl: '',
  });

  async function getData() {
    try {
      get({
        url: `home/ServiceLinksJson`,
      }).then((data) => {
        setData(data);
      });
    } catch (e) {
      console.error(e.status);
    }
  }

  async function getUser() {
    try {
      get({
        url: `account/getUserHeader`,
      }).then((data) => {
        setUser(data);
      });
    } catch (e) {
      console.error(e.status);
    }
  }

  useEffect(() => {
    getData();
    getUser();

    const userOptionsForm = document.getElementById('userOptionsForm');
    userOptionsForm.remove();
    document.querySelector('body').prepend(userOptionsForm);
    window.subscribeToCountryChangeInCart = subscribeToCountryChangeInCart;
  }, []);

  function subscribeToCountryChangeInCart() {
    try {
      const el = document.getElementById('cartChangeCountry');
      if (!isNil(el)) {
        const value = el.value;
        changeCountry(value);
      }
    } catch (error) {
      console.error('Error!', error);
    }
  }

  function changeCountry(val) {
    setData((prevState) => {
      return {
        ...prevState,
        country: val,
      };
    });
  }

  function handleChangeLanguage(e) {
    const val = e.target.value;
    if (val !== data.language) {
      setData((prevState) => {
        return {
          ...prevState,
          language: val,
        };
      });
    }
  }

  function handleChangeCountry(e) {
    const val = e.target.value;
    if (val !== data.country) {
      changeCountry(val);
    }
  }

  function handleChangeCurrency(e) {
    const val = e.target.value;
    if (val !== data.currency) {
      setData((prevState) => {
        return {
          ...prevState,
          currency: val,
        };
      });
    }
  }

  async function handleSubmitUserOptionsForm(e) {
    e.preventDefault();
    const res = await post({
      url: `home/ServiceLinksPostJson`,
      body: {
        Language: data.language,
        Country: data.country,
        Currency: data.currency,
        ReturnUrl: data.returnUrl,
        FullRedirect: false,
      },
    });

    const reEvaluateUrl = ({ country, currency, returnUrl }) => {
      const qsDestinationValue = common.getParameterByName(
        'destination',
        res.returnUrl,
      );
      const qsCurrencyValue = common.getParameterByName(
        'currency',
        res.returnUrl,
      );

      let newSearchParams = returnUrl;
      if (qsDestinationValue !== null && qsDestinationValue !== country) {
        newSearchParams = newSearchParams.replace(
          `destination=${qsDestinationValue}`,
          `destination=${toUpper(country)}`,
        );
      }
      if (qsCurrencyValue !== null && qsCurrencyValue !== currency) {
        newSearchParams = newSearchParams.replace(
          `currency=${qsCurrencyValue}`,
          `currency=${toUpper(currency)}`,
        );
      }
      return newSearchParams;
    };

    if (res.fullRedirect) {
      window.location.assign(res.returnUrl);
    } else {
      let updatedUrl = decodeURI(
        reEvaluateUrl({
          country: data.country,
          currency: data.currency,
          returnUrl: res.returnUrl,
        }),
      );
      window.location.assign(updatedUrl);
    }
  }

  function handleOpenUserOptionsForm(e) {
    e.preventDefault();

    const userOptionsForm = document.getElementById('userOptionsForm');
    const wrapper = userOptionsForm.parentElement.querySelector('div.wrapper');
    const offset = userOptionsForm.clientHeight;

    if (e.currentTarget.classList.contains('on')) {
      userOptionsForm.style.transform = 'scaleY(0)';
      wrapper.style.top = '0px';
      e.currentTarget.classList.remove('on');
    } else {
      userOptionsForm.style.transform = 'scaleY(1)';
      wrapper.style.top = offset + 'px';
      e.currentTarget.classList.add('on');
    }
  }

  function handleCloseUserOptionsForm(e) {
    e.preventDefault();

    const userOptionsForm = document.getElementById('userOptionsForm');
    const wrapper = userOptionsForm.parentElement.querySelector('div.wrapper');

    userOptionsForm.style.transform = 'scaleY(0)';
    wrapper.style.top = '0px';

    setTimeout(function () {
      document.getElementById('changeUserOptionsForm').classList.remove('on');
    }, 550);
  }

  const languageOptions = map(data.languages, (l, idx) => {
    return (
      <option key={idx} value={l.value}>
        {l.text}
      </option>
    );
  });
  const currencyOptions = map(data.currencies, (c, idx) => {
    return (
      <option key={idx} value={c.value}>
        {c.text}
      </option>
    );
  });
  const countryOptions = map(data.countries, (c, idx) => {
    return (
      <option key={idx} value={c.value}>
        {c.text}
      </option>
    );
  });

  const partnersLogo = map(data.partners, (p, idx) => {
    return (
      <a
        key={idx}
        href={p.url}
        title={p.name}
        rel='noopener'
        aria-label={p.name}
        target='_blank'
        style={{ marginLeft: '10px', marginRight: '10px' }}
      >
        <img
          src={common.contentFromCdn({
            path: `/Content/img/logo-small.${p.name}.svg`,
            keepUrlAsIs: false,
          })}
          alt={p.name}
          itemProp='image'
          className='logo_partner'
        />
      </a>
    );
  });

  const itemProfile = user.isAuthenticated ? (
    <>
      <li className='nav-secondary__item nav-secondary__item--profile'>
        {translateService.get(`serviceLinks.welcome`)} {user.firstName},
        <a
          className='nav-secondary__link link-invert'
          href={user.profileUrl}
          title={translateService.get(`serviceLinks.myProfile`)}
        >
          {translateService.get(`serviceLinks.myProfile`)}
        </a>
        -
        <a
          className='nav-secondary__link link-invert'
          href={user.ordersUrl}
          title={translateService.get(`serviceLinks.myOrders`)}
        >
          {translateService.get(`serviceLinks.myOrders`)}
        </a>
      </li>
      <li className='nav-secondary__item nav-secondary__item--logoff'>
        <a
          className='nav-secondary__link link-invert'
          href={common.getSiteUrl(`${window.$pathBase}Account/LogOff`)}
          title={translateService.get(`serviceLinks.logOff`)}
        >
          {translateService.get(`serviceLinks.logOff`)}
        </a>
      </li>
    </>
  ) : (
    <>
      <li className='nav-secondary__item'>
        <a
          className='nav-secondary__link'
          href={'#'}
          onClick={async (event) => {
            event.preventDefault();
            const linkUrl = common.getSiteUrl(
              `${window.$pathBase}Account/LogOn`,
            );

            await marketingAndAnalyticsService.recordLogonClick({
              linkUrl,
            });
            window.location.href = linkUrl;
          }}
          title={translateService.get(`serviceLinks.logIn`)}
        >
          {translateService.get(`serviceLinks.logIn`)}
        </a>
      </li>
      <li className='nav-secondary__item' style={{ color: 'white' }}>
        |
      </li>
      <li className='nav-secondary__item'>
        <a
          className='nav-secondary__link'
          href={'#'}
          onClick={async (event) => {
            event.preventDefault();
            const linkUrl = common.getSiteUrl(
              `${window.$pathBase}Account/Register`,
            );

            await marketingAndAnalyticsService.recordRegisterClick({
              linkUrl,
            });
            window.location.href = linkUrl;
          }}
          title={translateService.get(`serviceLinks.register`)}
        >
          {translateService.get(`serviceLinks.register`)}
        </a>
      </li>
    </>
  );

  return (
    <>
      <form id='userOptionsForm' className='form form--user-options'>
        <fieldset id='option_init' className='form__fieldset'>
          <div className='form__row'>
            <label
              htmlFor='Language'
              className='form__label icon icon--relative icon--comment'
            >
              {translateService.get(`serviceLinks.language`)}
            </label>
            <div className='form__element'>
              <select
                value={data.language}
                onChange={(e) => {
                  handleChangeLanguage(e);
                }}
                id='userOptionsCultures'
                className='form__select'
                name='Language'
              >
                {languageOptions}
              </select>
            </div>
          </div>
          <div className='form__row'>
            <label
              htmlFor='Country'
              className='form__label icon icon--relative icon--truck'
            >
              {translateService.get(`serviceLinks.country`)}
            </label>
            <div className='form__element'>
              <select
                value={data.country}
                onChange={(e) => {
                  handleChangeCountry(e);
                }}
                id='userOptionsCountries'
                className='form__select'
                name='Country'
              >
                {countryOptions}
              </select>
            </div>
          </div>
          <div className='form__row'>
            <label
              htmlFor='Currency'
              className='form__label icon icon--relative icon--money'
            >
              {translateService.get(`serviceLinks.currency`)}
            </label>
            <div className='form__element'>
              <select
                value={data.currency}
                onChange={(e) => {
                  handleChangeCurrency(e);
                }}
                id='userOptionsCurrencies'
                className='form__select'
                name='Currency'
              >
                {currencyOptions}
              </select>
            </div>
          </div>
          <div className='form__row'>
            <div
              className='form__element'
              style={{ display: 'flex', flexFlow: 'row nowrap', gap: '12px' }}
            >
              <button
                type='submit'
                className='button button--primary'
                onClick={(e) => {
                  handleSubmitUserOptionsForm(e);
                }}
              >
                {translateService.get(`serviceLinks.confirm`)}
              </button>
              <button
                id='closeUserOptionsForm'
                className='button button--link'
                onClick={(e) => {
                  handleCloseUserOptionsForm(e);
                }}
              >
                {translateService.get(`serviceLinks.cancel`)}
              </button>
            </div>
          </div>
        </fieldset>
      </form>
      {props.enablenews && toLower(props.enablenews) === 'true' && (
        <a
          id='logo_news'
          href={common.getSiteUrl() + '/news'}
          onClick={async (event) => {
            event.preventDefault();
            await marketingAndAnalyticsService.recordNewsHomepageClick();
            window.location.href = common.getSiteUrl() + '/news';
          }}
          title='news'
        >
          <img
            itemProp='image'
            src={common.contentFromCdn({
              path: `/content/img/logonews.${common.getSite()}.svg`,
              keepUrlAsIs: false,
            })}
            alt='news'
          />
        </a>
      )}
      <ul id='service_links' className='nav-secondary'>
        <li
          className='nav-secondary__item'
          style={{ color: 'white', bottom: '4px ' }}
        >
          <div style={{ display: 'inline-block' }}>
            <em style={{ position: 'relative', top: '4px' }}>
              {translateService.get(`serviceLinks.visitAlso`)}
            </em>
          </div>
          &nbsp;
          {partnersLogo}
        </li>
        <li className='nav-secondary__item nav-secondary__item--user-options'>
          <a
            href='#userOptionsForm'
            id='changeUserOptionsForm'
            className='nav-secondary__link'
            onClick={(e) => {
              handleOpenUserOptionsForm(e);
            }}
          >
            <span
              className='UOF-language icon icon--relative'
              style={{
                backgroundImage: data.language
                  ? `url("${common.contentFromCdn({
                      path: `/Content/img/flags/${data.language}.png")`,
                      keepUrlAsIs: false,
                    })}`
                  : '',
              }}
            ></span>
            <span className='UOF-country icon icon--relative icon--truck'>
              {data.country}
            </span>
            <span className='UOF-currency icon icon--relative icon--money'>
              {data.currency}
            </span>
          </a>
        </li>
        {itemProfile}
        <li className='nav-secondary__item nav-secondary__item--help'>
          <a
            className='nav-secondary__link link-invert'
            href={'#'}
            onClick={async (event) => {
              event.preventDefault();
              await marketingAndAnalyticsService.recordHelpClick();
              window.location.href = data.helpUrl;
            }}
            title={translateService.get(`serviceLinks.help`)}
          >
            {translateService.get(`serviceLinks.help`)}
          </a>
        </li>
      </ul>
    </>
  );
}

export default ServiceLinksDesktop;
